import createStyled from '../../../../../node_modules/.pnpm/@emotion_styled@11.14.0_@emotion_react@11.14.0_@types_react@19.0.1_react@18.3.1__@types_react@19.0.1_react@18.3.1/node_modules/@emotion/styled/base/dist/emotion-styled-base.esm.js';
import Typography from '../Typography/index.js';

// This is being exported as a styled component so that it
// can be targeted by other styled components (eg. Stack)
var Brandy = /*#__PURE__*/createStyled(Typography, process.env.NODE_ENV === "production" ? {
  target: "e15snftl0"
} : {
  target: "e15snftl0",
  label: "Brandy"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJyYW5keS5zdHlsZXMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTXdDIiwiZmlsZSI6IkJyYW5keS5zdHlsZXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuaW1wb3J0IFR5cG9ncmFwaHkgZnJvbSAnLi4vVHlwb2dyYXBoeSdcblxuLy8gVGhpcyBpcyBiZWluZyBleHBvcnRlZCBhcyBhIHN0eWxlZCBjb21wb25lbnQgc28gdGhhdCBpdFxuLy8gY2FuIGJlIHRhcmdldGVkIGJ5IG90aGVyIHN0eWxlZCBjb21wb25lbnRzIChlZy4gU3RhY2spXG5leHBvcnQgY29uc3QgQnJhbmR5ID0gc3R5bGVkKFR5cG9ncmFwaHkpYGBcbiJdfQ== */");

export { Brandy };
//# sourceMappingURL=Brandy.styles.js.map
